import { z } from 'zod';
import { isCalendarDate } from '../../dates/calendar-date.js';
import { beforeEarliestBusinessDateMessage, EARLIEST_BUSINESS_DATE, } from '../zod-helpers/earliest-business-date.js';
/** A Pacific business date as `YYYY-MM-DD`; rejects anything that is not a real calendar date. */
export const arBusinessDateInput = z.string().superRefine((value, context) => {
    if (!isCalendarDate(value)) {
        context.addIssue({ code: 'custom', message: 'Enter a date as YYYY-MM-DD.' });
    }
    else if (value < EARLIEST_BUSINESS_DATE) {
        context.addIssue({ code: 'custom', message: beforeEarliestBusinessDateMessage('Date') });
    }
});
//# sourceMappingURL=ar-business-date-input.js.map